export function lockPageZoom() {
  const onWheel = (event) => {
    if (event.ctrlKey || event.metaKey) event.preventDefault();
  };

  const onKeyDown = (event) => {
    if (!(event.ctrlKey || event.metaKey)) return;
    if (['+', '-', '=', '_', '0'].includes(event.key)) event.preventDefault();
  };

  const onGesture = (event) => event.preventDefault();

  window.addEventListener('wheel', onWheel, { passive: false });
  window.addEventListener('keydown', onKeyDown);
  document.addEventListener('gesturestart', onGesture);
  document.addEventListener('gesturechange', onGesture);
  document.addEventListener('gestureend', onGesture);
}
